import { uid } from 'uid';

// Обновление валидации блока формы
export const setValueForm = (setValue, name, value) => {
    try {
        setValue((prev) => { // Берем предыдущее значение состояния
            const obj = prev
            return {
                ...obj,
                [name]: value
            }
        })
    } catch (e) {
        console.error('FormHelper -> setValueForm')
    }
}

// Обновление валидации блока формы
export const updateValidate = (setValid, name, value) => {
    try {
        setValid((prev) => { // Берем предыдущее значение состояния
            const obj = prev
            return {
                ...obj,
                [name]: value
            }
        })
    } catch (e) {
        console.error('FormHelper -> updateValidate')
    }
}

// Обновление валидации блока формы
// { [idToDelete]: _, ...rest } = prev — це деструктуризація, яка "виймає" поле з обʼєкта.
// rest — це новий обʼєкт без видаленого ключа.
// Ми не мутуємо prev, тому React все правильно оновить.
export const deleteValidateById = (setValid, id) => {
    try {
        setValid((prev) => { // Берем предыдущее значение состояния
            const { [id]: _, ...rest } = prev;
            return rest;
        })
    } catch (e) {
        console.error('FormHelper -> deleteValidateById')
    }
}

// Валидация всего блока формы
// valid = useState блока
// setValidForm = useState всей формы
export const checkValid = (valid, setValidForm) => {
    let isValid = true

    if (valid) {
        for (const i in valid) {
            if (!valid[i]) {
                isValid = false
            }
        }
    }

    setValidForm(isValid)
}

// Додавання елементу в масив
export const addValueObjInArrayForm = (setValue, value) => {
    try {
        const valueWithId = {
            ...value,
            id: uid(),
        }
        setValue(prev => [...prev, valueWithId]);
    } catch (e) {
        console.error('FormHelper -> addValueObjInArrayForm')
    }
}

// Оновлення елементу (саме весь обʼєкт по ID) в масиві.
export const updateValueObjInArrayForm = (setValue, id, value) => {
    try {
        setValue(prev => {
            // console.log('prev', prev)
            if (prev && prev.length > 0) { // Якщо є попередній стан
                if (prev.some(el => el.id === id)) { // Якщо є елемент в масиві з потрібним ID, то оновлюємо
                    return prev.map(el => 
                        el.id === id ? value : el
                    )
                } else { // Якщо ще не має, то додаємо
                    return [...prev, value]
                }
            } else { // Якщо немає попереднього стану
                return [value]
            }
        })
    } catch (e) {
        console.error('FormHelper -> updateValueObjInArrayForm')
    }
}

// // Оновлення елементу валідації (саме весь обʼєкт по ID) в масиві.
// export const updateValidateInArrayForm = (setValue, id, value) => {
//     try {
//         setValue(prev => {
//             return prev.map(el => 
//                 el.id === id ? value : el
//             )
//         })
//     } catch (e) {
//         console.error('FormHelper -> updateValidateInArrayForm')
//     }
// }

// Оновлення елементу (саме весь обʼєкт по ID) в масиві.
export const deleteObjInArrayForm = (setValue, id) => {
    try {
        setValue(prev => {
            return prev.filter(el => el.id !== id)
        })
    } catch (e) {
        console.error('FormHelper -> deleteObjInArrayForm')
    }
}